module.exports = __webpack_public_path__ + "img/wsc.png";